import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "QuestionGod";
const DEFAULT_DESC = "Explore the questions of the Bible. Curiosity breeds intimacy with God.";

// React 19 hoists <title>/<meta>/<link> rendered anywhere into <head>.
// index.html ships site-wide defaults (data-seo-default) for crawlers that do not run JS;
// they are removed once the app renders so each page's tags are the only ones present.
export default function Seo({ title, description = DEFAULT_DESC, image, type = "website" }) {
  const { pathname } = useLocation();
  useEffect(() => {
    document.head.querySelectorAll("[data-seo-default]").forEach((el) => el.remove());
  }, []);
  const full = title ? `${title} | ${SITE}` : `${SITE} - The Questions of the Bible`;
  const url = `${window.location.origin}${pathname}`;
  const desc = description.length > 300 ? `${description.slice(0, 297).trimEnd()}...` : description;
  return (
    <>
      <title>{full}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      {image && <meta property="og:image:width" content="1200" />}
      {image && <meta property="og:image:height" content="630" />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
    </>
  );
}
